import _ from "lodash";

export function restoreItemMultichoiceResponse(item, responseValues) {
	let values = [];

	_.each(responseValues, (responseValue) => {

		let foundItem = _.find(item.choiceItems, { value: responseValue });
		if (!_.isUndefined(foundItem)) {
			values.push(
				{
					value: foundItem.value,
					label: foundItem.label
				}
			)
		}
	});
	return values;
}

export function getResponseFromMultichoiceItem(item) {
	let arr = [];
	_.each(item.value, (value) => {
		if (_.isObject(value)) {
			arr.push(value.value);
		}
	});
	return arr.join('[,]');
}

//return response type and value
export function getResponseFromItem(item) {

	let type = item.type.toLowerCase();
	let response;

	//TODO: need to determine what values to store as part of learner response
	switch (type) {
		case "item":
			response = {
				type: "true-false",
				value: (item.value === true) ? "true" : "false"
			}
			break;
		case "itemtextinput":
		case "itemtextinputmultiline":
		case "itemdate":
		case "itemdatetime":
			response = {
				type: "fill-in",
				value: item.value
			}
			break;
		case "itembarcodescanner":
			response = {
				type: "fill-in",
				value: _.get(item, "barcode.data")
			}
			break;
		case "itempicker":
		case "itemyesno":
		case "itemchoicesingle":
			response = {
				type: "choice",
				value: item.value
			}
			break;
		case "itemaddress": //object
		case "itemlocation": //object
		case "itemimagepicker": //value, valueUrls
			response = {
				type: "other",
				value: JSON.stringify(item.value)
			}
			break;
		case "itemchoicemulti": //array
			response = {
				type: "choice",
				value: getResponseFromMultichoiceItem(item)
			};
			break;

		default:
			response = {
				type: "other",
				value: JSON.stringify(item.value)
			}
			break;
	}
	return response;
}

export function restoreStateForObject(object, objectState) {
	_.each(objectState, (value, key) => {
		if (key !== "type") {
			object[key] = value;
		}
	})
}